// extracted by mini-css-extract-plugin
export default {"mainHeader":"Layout_mainHeader__QoAnN"};